/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { createRoute, Route } from 'framework/routing';
import ShowArtifactPage from 'domain/documents/artifact/show';
import ArtifactContext from 'domain/documents/artifact/ArtifactContext';
import { READ_ARTIFACT } from 'domain/shared/artifact';
import { ProtectedRouter } from 'infrastructure/routing';

const ARTIFACTS_PATH = '/artifacts';

const useArtifactRoute = () => {
  return createRoute({ listRoute: ARTIFACTS_PATH });
};

const ArtifactRouter = () => {
  const { singleEntityRoute } = useArtifactRoute();
  const { isAuthenticated } = useAuthenticationService();

  return (
    <ProtectedRouter basePath={ARTIFACTS_PATH}>
      <Routes>
        <Route
          path={singleEntityRoute}
          element={
            <ArtifactContext permissionToCheck={READ_ARTIFACT}>
              <ShowArtifactPage />
            </ArtifactContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ArtifactRouter.getRouterPath = () => `${ARTIFACTS_PATH}/*`;

export default ArtifactRouter;
